import { Box, SxProps, Theme } from '@mui/material'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { colors } from '../../theme/options'

type PlayStationNetworkIconProps = {
  sx?: SxProps<Theme>
  sxSvg?: SxProps<Theme>
}

const PlayStationIcon: FC<PlayStationNetworkIconProps> = ({ sx, sxSvg }) => (
  <Box
    sx={{
      borderRadius: '50%',
      backgroundColor: colors.playstation,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      ...sx,
    }}
  >
    <PlayStationSVG sx={{ ...sxSvg }} />
  </Box>
)

export const PlayStationSVG: FC<SvgIconProps> = (props) => {
  const { t } = useTranslation('vpc')
  const psnLabel = t('playstationnetwork.logo')
  return (
    <SvgIcon
      aria-label={psnLabel}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}
    >
      <title>{psnLabel}</title>
      <desc>{psnLabel}</desc>
      <path d="M8.984 2.596v17.547l3.915 1.261V6.688c0-.69.304-1.151.794-.991.636.18.76.814.76 1.505v5.875c2.441 1.193 4.362-.002 4.362-3.152 0-3.237-1.126-4.675-4.438-5.827-1.307-.448-3.728-1.186-5.39-1.502zm4.656 16.241l6.296-2.275c.715-.258.826-.625.246-.818-.586-.192-1.637-.139-2.357.123l-4.205 1.5V14.98l.24-.085s1.201-.42 2.913-.615c1.696-.18 3.785.03 5.437.661 1.848.601 2.04 1.472 1.576 2.072-.465.6-1.622 1.036-1.622 1.036l-8.544 3.107V18.86zM1.807 18.6c-1.9-.545-2.214-1.668-1.352-2.32.801-.586 2.16-1.052 2.16-1.052l5.615-2.013v2.313L4.205 17c-.705.271-.825.632-.239.826.586.195 1.637.15 2.343-.12L8.247 17v2.074c-.12.03-.256.044-.39.073-1.939.331-3.996.196-6.038-.479z" />
    </SvgIcon>
  )
}

export default PlayStationIcon
